<template lang="pug">
.add-comment.separate-gradient.middle.down
	.comment-wrapper
		.input-container
			p.reply(v-if='replyToUser') Replying to @{{ replyToUser }}
			input(
				v-model='text'
				@keydown.enter='sendComment'

				placeholder='Leave a comment...'
			)
		.send(
			@click='sendComment'
			v-if='text'
		)
		.icon-close(
			:class='{ show : text || replyToUser }'
			@click='clear'
		)
</template>

<script>
import { objectOrNull } from '@/lib/vue-validators';

export default {
	name : 'add-comment',

	props : {
		replyComment : {
			type      : Object,
			validator : objectOrNull,
		}
	},

	data : () => ( {
		text : '',
	} ),

	computed : {
		replyToUser() {
			const { replyComment } = this;

			if ( !replyComment ) {
				return '';
			}

			return replyComment.user;
		},
	},

	methods : {
		sendComment() {
			const text = this.text.trim();

			if ( !text.length ) {
				return;
			}
			this.$emit( 'comment', text );

			this.text = '';

		},

		clear() {

			this.text = '';

			this.$emit( 'clear' );
		}
	}
};
</script>

<style lang="scss">
.add-comment {

	.comment-wrapper {
		box-shadow: $box-shadow-primary;
		border-radius: 25px;
		padding: 10px 20px;
		margin: 15px;
		background: white;
		display: flex;
		align-items: center;

		.input-container {
			display: flex;
			flex-direction: column;
			flex: 1 1 0;

			.reply {
				margin-bottom: 5px;
				color: $color-primary;
				font-weight: 500;
			}

			input {
				flex: 1 1 0;
				color: $text-primary;
				width: 100%;
			}
		}

		.send {
			flex: 0 0 auto;
			margin-left: 10px;
			width: 25px;
			height: 25px;
			border-radius: 50%;
			border: 2px solid $color-primary;
			position: relative;
			display: none;

			&::after {
				content: ' ';
				position: absolute;
				height: 8px;
				width: 8px;
				border: 2px solid $color-primary;
				border-bottom: 0;
				border-left: 0;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -33%) rotate(-45deg);
			}
		}

		.icon-close {
			pointer-events: none;
			opacity: 0;

			&.show {
				pointer-events: all;
				opacity: 1;
			}
		}
	}
}

@media only screen and ( max-width: 640px ) {

.add-comment {

	.comment-wrapper {

		.send {
			display: block;
		}

		.icon-close {
			display: none;
		}
	}
}
}
</style>
